import React from 'react';
import { Col } from '../../components/RowCol';

type Props = {
	roundName: string;
	children: React.ReactNode;
};

const RoundEditorLayout: React.FC<Props> = ({
	roundName, children,
}) => (
	<Col style={{
		border: '2px solid white',
		position: 'relative',
		padding: '10px',
	}}>
		<div style={{
			position: 'absolute',
			top: '-20px',
			left: '20px',
			zIndex: 1,
			backgroundColor: 'black',
			paddingLeft: '5px',
			paddingRight: '5px',
			fontSize: '30px',
		}}>
			{roundName}
		</div>

		<div style={{
			padding: '20px',
		}}>
			{children}
		</div>
	</Col>
);

export default RoundEditorLayout;
